"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _useCategoryTree2 = require("@deosite/api/hooks/common/useCategoryTree");
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("@deosite/api/hooks/common/useAnalytics4AndCommerceTags"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var RecentlyViewed = function RecentlyViewed(props) {
  var products = props.products,
    roundness = props.roundness;
  var wrapper = (0, _react.useRef)(null);
  var translations = {
    recentlyViewed: (0, _langLibrary["default"])("Recently viewed")
  };
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var productImageWidth = 65;
  var _useState = (0, _react.useState)(6),
    productsAmount = _useState[0],
    setProductsAmount = _useState[1];
  (0, _react.useEffect)(function () {
    setProductsAmount(Math.floor(wrapper.current.offsetWidth / productImageWidth));
  }, []);
  var productsToDisplay = productsAmount < 7 ? products.slice(0, productsAmount) : products.slice(0, 6);
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  return __jsx(_Box["default"], {
    ref: wrapper
  }, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      mb: "s7",
      textAlign: "center",
      color: "main"
    },
    as: "h4"
  }, translations.recentlyViewed), __jsx(_Box["default"], {
    sx: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    }
  }, productsToDisplay.map(function (product, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        width: productImageWidth + "px",
        mr: "4px",
        "&:last-of-type": {
          mr: "0px"
        }
      },
      onClick: function onClick() {
        return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
      }
    }, __jsx(Link, {
      route: "product-page",
      params: product
    }, __jsx(_LinkRaw["default"], {
      title: product.name
    }, __jsx(_Image["default"], {
      overlay: true,
      image: product.image,
      quality: global.__appConfig__.smallImageQuality,
      cloudflareEnabled: global.__appConfig__.smallImageCloudflareEnabled,
      minified: true,
      roundness: roundness
    }))));
  })));
};
var _default = RecentlyViewed;
exports["default"] = _default;